<template>
    <div class="alert" :class="alertClass" v-if="alerts.length">
        <template v-for="alert in alerts">{{ alert }}<br></template>
    </div>
</template>

<script>
    export default {
        name: 'alerts',

        props: {
            messages: {
                default() {
                    return [];
                },
            },

            type: {
                default() {
                    return 'error';
                },
            },

            errorCode: {
                default() {
                    return null;
                },
            },
        },

        data() {
            return {
                classes: {
                    error: 'alert-danger',
                    notice: 'alert-warning',
                    success: 'alert-success',
                },
            }
        },

        computed: {
            alerts() {
                // We'll allow single and multiple messages
                if (!this.messages) {
                    return [];
                }
                if (typeof this.messages !== 'object') {
                    return [this.messages];
                }

                return this.messages;
            },

            alertClass() {
                if (this.classes[this.type]) {
                    return this.classes[this.type];
                }

                return '';
            },

            code() {
                return this.errorCode;
            },
        },
    }
</script>
